import Vue from 'vue';
import TableSearch from '@/components/Basis/TableSearch';
import TablePagination from '@/components/Basis/TablePagination/Table';
import KnowInfoG from '@/views/knowledge/components/KnowInfo';
import RemoteJs from '@/components/Basis/Remote/index.vue'
//  import VirtualList from 'vue-virtual-scroll-list'
import TableSearchIndex from '@/components/Basis/TableSearch/search';

import {
	ImageMessage,
	TextMessage,
	VideoMessage,
	VoiceMessage,
	SystemMessage,
	FileMessage,
	CardMessage,
	LinkMessage,
	MiniProgramMessage,
	historyList
} from '@/components/Chat'
import SurveyDesign from './SurveyDesign';
//聊天信息 包含文本 图片 视频 语音 卡片 新闻 链接
Vue.component('ImageMessage', ImageMessage)
Vue.component('TextMessage', TextMessage)
Vue.component('VideoMessage', VideoMessage)
Vue.component('VoiceMessage', VoiceMessage)
Vue.component('SystemMessage', SystemMessage)
Vue.component('FileMessage', FileMessage)
Vue.component('CardMessage',CardMessage)
Vue.component('LinkMessage',LinkMessage)
Vue.component('MiniProgramMessage',MiniProgramMessage)
Vue.component('historyList',historyList)
Vue.component('KnowInfoG', KnowInfoG)

Vue.component('table-search', TableSearch); // ! 基础页面搜索
Vue.component('table-pagination', TablePagination); // ! 基础页面表格+分页
Vue.component('remote-js', RemoteJs); 
Vue.component('table-search-index', TableSearchIndex);

Vue.component('virtual-list', VirtualList) // ! 长列表加载
Vue.component('SurveyDesign', SurveyDesign);